import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/app/components/ui/dialog'
import { Button } from '@/app/components/ui/button'
import { Input } from '@/app/components/ui/input'

export interface ChangeCashierModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  password: string
  setPassword: (password: string) => void
  handleReleaseRegister: () => void
  setShowChangeCashier: (show: boolean) => void
  isSubmitting?: boolean
}

export function ChangeCashierModal({
  open,
  onOpenChange,
  password,
  setPassword,
  handleReleaseRegister,
  setShowChangeCashier,
  isSubmitting = false,
}: ChangeCashierModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" onInteractOutside={(e: any) => e.preventDefault()} onEscapeKeyDown={(e: any) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>Liberar Caja Registradora</DialogTitle>
          <DialogDescription className="sr-only">
            Liberar la asignación de la caja actual para seleccionar una diferente
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="rounded-lg border border-yellow-200 bg-yellow-50 p-4">
            <p className="text-sm text-yellow-900">
              Para desasignar esta caja y seleccionar otra, debes ingresar tu contraseña de usuario por seguridad.
            </p>
          </div>

          <div className="space-y-2">
            <label className="text-sm font-medium text-slate-700">
              Contraseña:
            </label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              disabled={isSubmitting}
            />
          </div>

          <div className="flex gap-2">
            <Button
              onClick={handleReleaseRegister}
              disabled={!password || isSubmitting}
              className="flex-1"
            >
              {isSubmitting ? 'Liberando...' : 'Liberar Caja'}
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                setShowChangeCashier(false)
                setPassword('')
              }}
              disabled={isSubmitting}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
